import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const songImporterSelectors =
  importerSelectors('song.importer')

export default songImporterSelectors
